<script setup>
import { useI18n } from 'vue-i18n';
import {
  COMPONENT_CATEGORIES,
  COMPONENT_ICONS,
  COMPONENT_LABELS,
  COMPONENT_DESCRIPTIONS,
  createDefaultComponent,
} from 'dashboard/helper/whatsappFlowHelper';

const props = defineProps({
  disabledTypes: { type: Array, default: () => [] },
});

const emit = defineEmits(['select', 'close']);
const { t } = useI18n();

function isDisabled(type) {
  return props.disabledTypes.includes(type);
}

function onSelect(type) {
  if (isDisabled(type)) return;
  emit('select', createDefaultComponent(type));
}
</script>

<template>
  <div
    class="absolute inset-0 z-20 bg-black/30 flex items-center justify-center"
    @click.self="emit('close')"
  >
    <div
      class="bg-n-solid-2 rounded-xl shadow-xl w-96 max-h-[80vh] overflow-hidden flex flex-col"
    >
      <div
        class="flex items-center justify-between px-4 py-3 border-b border-n-weak"
      >
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ t('WHATSAPP_FLOWS.PALETTE.TITLE') }}
        </h3>
        <button
          class="p-1 rounded text-n-slate-9 hover:bg-n-alpha-1"
          @click="emit('close')"
        >
          <span class="i-lucide-x size-4" />
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4 space-y-4">
        <div v-for="category in COMPONENT_CATEGORIES" :key="category.key">
          <h4
            class="text-[10px] font-semibold text-n-slate-9 uppercase tracking-wide mb-2"
          >
            {{ t(category.label) }}
          </h4>
          <div class="grid grid-cols-2 gap-2">
            <button
              v-for="type in category.components"
              :key="type"
              :disabled="isDisabled(type)"
              class="flex items-start gap-2 px-3 py-2.5 rounded-lg border transition-colors text-left"
              :class="
                isDisabled(type)
                  ? 'border-n-weak opacity-40 cursor-not-allowed'
                  : 'border-n-weak hover:border-n-brand hover:bg-n-brand-subtle/30'
              "
              @click="onSelect(type)"
            >
              <span
                class="size-4 text-n-slate-9 shrink-0"
                :class="[COMPONENT_ICONS[type]]"
              />
              <div class="min-w-0">
                <span class="text-xs font-medium text-n-slate-11 block">
                  {{ COMPONENT_LABELS[type] }}
                </span>
                <span
                  v-if="COMPONENT_DESCRIPTIONS[type]"
                  class="text-[10px] text-n-slate-9 block leading-tight mt-0.5"
                >
                  {{ t(COMPONENT_DESCRIPTIONS[type]) }}
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
